import React from "react";
import "./Main.css";
import StripImage from "../../assets/StripImage.webp";
import BrandProm from "../../assets/BrandProm.webp";
import {
  CARDS_DATA as CardData,
  ITEMS_DATA as ItemData,
} from "../../utility/data/Data";

const Main = () => {
  let show = false;
  return (
    <div className="mainContainer">
      <div className="strip">
        <div className="maxWidth flex innerStrip">
          <div className="flex leftStrip">
            <div className="flex absoluteCenter leftStripImage">
              <img src={StripImage} alt="Strip Image" className="stripImage" />
            </div>
            <div className="stripText">
              Order Paan items, munchies and much more on our new Dunzo Mo app
            </div>
          </div>
          <div className="flex rightStrip cursorPointer">
            Download Dunzo Mo app now
            <div className="flex absoluteCenter">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-chevron-right"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="#00B37A"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="maxWidth flex absoluteCenter column prom">
        <img src={BrandProm} alt="Dunzo Daily" className="maxWidth promImage" />
        <button type="button" className="dailyDunzo" >Try Dunzo Daily</button>
      </div>

      <div className="main">
        <div className="flex maxWidth location">
          <div className="home">Home</div>
          <div className="flex absoluteCenter addressArrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-arrow-narrow-right"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="#c9cdd8"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M5 12l14 0"></path>
              <path d="M15 16l4 -4"></path>
              <path d="M15 8l4 4"></path>
            </svg>
          </div>
          <div className="city">Bangalore</div>
        </div>
        <div className="info maxWidth">
          <div className="cityInfo">Bangalore</div>
          <div className="cityDesc">
            Why step out when you can get everything delivered home with the tap
            of a button? Bangalore’s favourite delivery app gets you Food,
            Grocery, Medicine, Pet Supplies, Fruits & Vegetables, Meat & Fish,
            Health & Wellness, Gifts and Send Packages from one end of the city
            to the other. From your local kirana stores to your favourite
            brands, grocery shopping to your forgotten charger, we are always on
            the move for you. Why worry about your chores, when you can get it
            all Dun!
          </div>
        </div>
        <div className="maxWidth flex cardContainer">
          {CardData.map((data) => {
            return (
              <div key={data.id} className="card cursorPointer">
                <img
                  src={data.banner[`CardBanner${data.id}`]}
                  alt={data.id}
                  className="card"
                />
              </div>
            );
          })}
        </div>
        <div className="maxWidth flex itemContainer">
          {ItemData.map((data) => {
            if (data.id === "3") {
              show = true;
            } else {
              show = false;
            }
            return (
              <div key={data.id} className="item cursorPointer">
                <div>
                  {show && (
                    <p
                      style={{
                        float: "right",
                        marginTop: -20,
                        marginRight: -15,
                      }}
                      className="live flex absoluteCenter"
                    >
                      LIVE
                    </p>
                  )}
                  <img
                    src={data.banner[`ItemBanner${data.id}`]}
                    alt={data.id}
                    className="cursorPointer itemImage"
                  />
                  <div>{data.title}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Main;
